import { getStore } from "./storeUtils";

export function ActivatePopup(type, setPopup, deleteSite, domainName) {
  switch (type) {
    case "error":
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Domain Limit Reached",
        popupSubtitle: "You can't add any more domains to your plan.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "success":
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray it's done!!",
        popupSubtitle: "Changes updated successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "error-del":
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Something Went Wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "error-warn":
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "user-warn":
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Permission Denied",
        popupSubtitle: "You do not have permission to perform this action.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "warn-primary":
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Oops! can't proceed",
        popupSubtitle: "Cannot perform action on live domain",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "delete-site":
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Delete Site?",
        popupSubtitle:
          "Are you sure you want to delete this site? This action cannot be undone.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          deleteSite();
        },
      });
      break;

    case "domain-add-in-progress":
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Domain Setup in Progress",
        popupSubtitle: (
          <>
            The domain{" "}
            <span style={{ fontWeight: 600, color: "#000" }}>
              {domainName}
            </span>{" "}
            is currently being configured. We'll notify you once the process is
            complete.
          </>
        ),
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "site-deletion-in-progress":
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Deletion in Progress",
        popupSubtitle:
          "This site is being deleted. You won't be able to access it while the deletion is running. We'll notify you once it's complete.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "org-deletion-in-progress":
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Deletion in Progress",
        popupSubtitle:
          "This organization is being deleted. You won't be able to access it while the deletion is running. We'll notify you once it's complete.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "blueprint-creation-in-progress":
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Creation in Progress",
        popupSubtitle:
          "This blueprint is still being created. You won't be able to use it until it's ready. We'll notify you once it's complete.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
      break;

    case "none":
      setPopup({ popupState: false });
      break;
  }
}

/**
 * Not every sites endpoint returns `deletionInProgress` (the sites-overview list
 * does, topPerformSites / site-details may not), so resolve the flag from the
 * site object in hand first and fall back to whatever is already in the store.
 * Accepts either a site object or a bare siteId.
 */
export function isSiteDeletionInProgress(site) {
  if (site?.deletionInProgress === true) {
    return true;
  }

  const siteId =
    site !== null && typeof site === "object" ? site?.siteId : site;
  if (siteId === undefined || siteId === null) {
    return false;
  }

  const sitesInfo = getStore().getState()?.sitesInfo;
  const candidates = [
    ...(sitesInfo?.siteDetails?.data || []),
    ...(sitesInfo?.topSites?.data || []),
    sitesInfo?.selectedSite,
  ];

  return candidates.some(
    (item) =>
      item?.deletionInProgress === true &&
      String(item?.siteId) === String(siteId),
  );
}

/**
 * Shows the "deletion in progress" popup and returns true when the site is being
 * deleted, so callers can `if (blockIfSiteDeleting(...)) return;` before
 * navigating or opening an external portal.
 */
export function blockIfSiteDeleting(site, setPopup) {
  if (!isSiteDeletionInProgress(site)) {
    return false;
  }
  ActivatePopup("site-deletion-in-progress", setPopup);
  return true;
}

/**
 * Same idea as `isSiteDeletionInProgress`, for organizations: the org in hand
 * (a dashboard card, a client org from the slider) may not carry the flag, so
 * fall back to whatever the store already knows about that orgId.
 * Accepts either an org object or a bare orgId.
 */
export function isOrgDeletionInProgress(org) {
  if (org?.deletionInProgress === true) {
    return true;
  }

  const orgId = org !== null && typeof org === "object" ? org?.orgId : org;
  if (orgId === undefined || orgId === null) {
    return false;
  }

  const organizationsInfo = getStore().getState()?.organizationsInfo;
  const candidates = [
    ...(organizationsInfo?.dashboardOrg?.data || []),
    ...(organizationsInfo?.userOrgs?.data || []),
    organizationsInfo?.selectedOrg,
  ];

  return candidates.some(
    (item) =>
      item?.deletionInProgress === true && String(item?.orgId) === String(orgId),
  );
}

/**
 * Shows the "deletion in progress" popup and returns true when the organization
 * is being deleted, so callers can `if (blockIfOrgDeleting(...)) return;` before
 * navigating into the org.
 */
export function blockIfOrgDeleting(org, setPopup) {
  if (!isOrgDeletionInProgress(org)) {
    return false;
  }
  ActivatePopup("org-deletion-in-progress", setPopup);
  return true;
}
